<template>
    <Modal :close_button="true" :size="'modal-md'" mid="manage-store-category">
        <template v-slot:header>
            <span v-if="category && category.id">{{$t('management_console.category_modal.edit_title')}}</span>
            <span v-else>{{$t('management_console.category_modal.create_title')}}</span>
        </template>
        <template v-slot:body>
            <div class="row mb-3">
                <div class="col">
                    <label class="form-label fw-bold">{{$t('management_console.common.name')}}<span class="ms-1 text-red-500">*</span></label>
                    <input v-model="form.name" type="text" class="form-control form-control-lg" :placeholder="$t('management_console.category_modal.name_placeholder')" :aria-label="$t('management_console.common.name')">
                    <small class="d-block mt-1 mb-2">{{$t('management_console.category_modal.name_help')}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <small><span class="text-red-500">*</span> {{$t('console.fields_are_mandatory')}}</small>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button :disabled="!valid_form && !loading" type="button" class="btn btn-primary bg-gradient px-4" @click="submit()">
                <span v-if="category && category.id">{{$t('controls.update')}}</span>
                <span v-else>{{$t('controls.create')}}</span>
            </button>
            <button type="button" class="btn px-4" @click="cancel()">{{$t('controls.cancel')}}</button>
        </template>
    </Modal>
</template>

<script>
import InventoryCategoryStore from '@/common/store/inventory_category.js'

export default {
    props: {
        category: {
            type: Object,
            default: () => {}
        }
    },
    data: function () {
        return {
            loading: false,
            form: {
                name: ''
            }
        }
    },
    computed: {
        valid_form: function () {
            return this.form.name.length > 3 &&
                this.form.name.length < 255
        }
    },
    watch: {
        category: function () {
            if (this.category && this.category.id) {
                this.form.name = this.category.name
            } else {
                this.form.name = ''
            }
        }
    },
    methods: {
        cancel: async function () {
            this.$bus.$emit('Modal/hide/manage-store-category')
        },
        submit: async function () {
            this.loading = true

            const payload = {
                name: this.form.name
            }

            let response = null
            if (this.category && this.category.id) {
                response = await InventoryCategoryStore.dispatch('UPDATE', {
                    id: this.category.id,
                    params: payload
                })
            } else {
                response = await InventoryCategoryStore.dispatch('CREATE', payload)
            }

            if (response.status === 200) {
                this.$bus.$emit('Modal/hide/manage-store-category')
                this.form.name = ''
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.operation_success'), msg: this.$t('notifications.operation_success_description'), level: 'success' })
            } else if (response.status === 409) {
                this.$bus.$emit('Notification/show', { title: this.$t('management_console.category_modal.limit_title'), msg: this.$t('management_console.category_modal.limit_description'), level: 'danger' })
            } else if (response.status === 422) {
                this.$bus.$emit('Notification/show', { title: this.$t('management_console.category_modal.exists_title'), msg: this.$t('management_console.category_modal.exists_description'), level: 'danger' })
            } else {
                this.$bus.$emit('Notification/show', { title: this.$t('notifications.something_went_wrong'), msg: this.$t('notifications.please_retry_the_operation_or_refresh'), level: 'danger' })
            }

            this.loading = false
        }
    }
}
</script>
